import React, { useState }from 'react';
import Product from '../components/Product';
import { useGetProductsQuery } from '../../app/config/redux/slices/api/productApiSlice';
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removeFromCart } from "../../app/config/redux/slices/cartSlice";
import { Link, useSearchParams } from 'react-router-dom'

const ProductListing = ({quantity, filters , search, sidebarController}) =>{

    
    let [grid, setGrid] = useState(false)

        
    const [searchParams, setSearchParams] = useSearchParams();

    const page = parseInt(searchParams.get('page')) || 1;
    const categoryParam = searchParams.get('category');
    const vendorParam = searchParams.get('vendor');

    

    const [limit, setLimit] = useState(20);

    const { data, isLoading, isFetching, error } = useGetProductsQuery({
            limit,
            page,
            quantity,
            filters,
            search
        });

    const products = data?.products?.data || [];
    const size = data?.products?.total || 0;
    const totalPages = data?.products?.last_page || 1;
    const currentPage = data?.products?.current_page || 1;
    console.log("Products Data:", data?.products?.from);


    // ✅ UPDATE PAGE IN URL (keeps category, vendor, search)
    const updatePageInUrl = (newPage) => {
        const params = new URLSearchParams(searchParams);
        params.set("page", newPage);
        setSearchParams(params);
    };

    const handleNextPage = () => {
        if (data?.products?.next_page_url) {
            updatePageInUrl(page + 1);
        }
    };

    const handlePrevPage = () => {
        if (data?.products?.prev_page_url) {
            updatePageInUrl(page > 1 ? page - 1 : page);
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            updatePageInUrl(newPage);
        }
    };

    const dispatch = useDispatch();

    const productCategories = useSelector(
        (state) => state.api.queries?.['getProductCategories(undefined)']?.data
    );

    const vendorData = useSelector(
        (state) =>state.api.queries?.["getVendors(undefined)"]?.data?.data ?? []
    ) || [];

    const selectedCategory = productCategories?.find(
        (cat) => cat.id.toString() === categoryParam || cat.slug === categoryParam
    );

    const selectedVendor = vendorData.find(
        (vendor) =>vendor.id.toString() === vendorParam || vendor.vendor?.id.toString() === vendorParam
    );

    const cartItems = useSelector((state) => state.cart.cartItems);
    const cartItemsMap = cartItems.reduce((acc, item) => {
        acc[item.product.id] = item.quantity;
        return acc;
    }, {});
    
    return(  
        <>
            {/* Top Start */}
            <div className="flex-between gap-16 flex-wrap mb-40 ">

                <span className="text-gray-900">
                    Showing {data?.products?.from}-{data?.products?.to} of {size} result
                    {selectedCategory && 
                        <> 
                            {" "}
                            in {" "}
                            <strong>
                                {selectedCategory.name.charAt(0).toUpperCase() + selectedCategory.name.slice(1)}
                            </strong>
                        </>
                    }
                    {selectedVendor && (
                        <>
                            {" "}
                            by{" "}
                            <strong>
                                {selectedVendor.name.charAt(0).toUpperCase() +
                                selectedVendor.name.slice(1)}
                            </strong>
                        </>
                    )}


                </span>
                <div className="position-relative flex-align gap-16 flex-wrap">
                    <div className="list-grid-btns flex-align gap-16">
                        <button onClick={() => setGrid(true)}
                            type="button"
                            className={`w-44 h-44 flex-center border rounded-6 text-2xl list-btn border-gray-100 ${grid === true && "border-main-600 text-white bg-main-600"}`}
                        >
                            <i className="ph-bold ph-list-dashes" />
                        </button>
                        <button onClick={() => setGrid(false)}
                            type="button"
                            className={`w-44 h-44 flex-center border rounded-6 text-2xl grid-btn border-gray-100 ${grid === false && "border-main-600 text-white bg-main-600"}`}
                        >
                            <i className="ph ph-squares-four" />
                        </button>
                    </div>
                    {/* <div className="position-relative text-gray-500 flex-align gap-4 text-14">
                        <label htmlFor="sorting" className="text-inherit flex-shrink-0">
                            Sort by:{" "}
                        </label>
                        <select defaultValue={1}
                            className="form-control common-input px-14 py-14 text-inherit rounded-6 w-auto"
                            id="sorting"
                        >
                            <option value={1} >
                                Popular
                            </option>
                            <option value={1}>Latest</option>
                            <option value={1}>Trending</option>
                            <option value={1}>Matches</option>
                        </select>
                    </div> */}
                    <button onClick={sidebarController}
                        type="button"
                        className="w-44 h-44 d-lg-none d-flex flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
                    >
                        <i className="ph-bold ph-funnel" />
                    </button>
                </div>
            </div>
            {/* Top End */}
            <div className={`list-grid-wrapper ${grid && "list-view"}`}>
                {products.map((product) => {
                    const cartQuantity = cartItemsMap[product.id] || 0;
                        return (
                                <Product
                                    product={product}
                                    cartQuantity={cartQuantity}
                                />
                        );
                })}
            </div>
            {/* Pagination Start */}
            <ul className="pagination flex-center flex-wrap gap-16">
                <li className={`page-item ${
                        !data?.products?.prev_page_url ? "disabled" : ""
                    }`}
                >
                    <Link
                        className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                        onClick={handlePrevPage}
                        disabled={!data?.products?.prev_page_url}
                    >
                        <i className="ph-bold ph-arrow-left" />
                    </Link>
                </li>
                {Array.from(
                { length: totalPages },
                (_, index) => index + 1
                ).map((pageNum) => (
                <li className={`page-item ${
                        pageNum === currentPage ? "active" : ""
                    }`}
                >
                    <Link
                        key={pageNum}
                        className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                        onClick={() => handlePageChange(pageNum)}
                    >
                        {pageNum}
                    </Link>
                </li>
                ))}
                <li className={`page-item ${
                        !data?.products?.next_page_url ? "disabled" : ""
                    }`}
                >
                    <Link
                        className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                        onClick={handleNextPage}
                        disabled={!data?.products?.next_page_url}
                    >
                        <i className="ph-bold ph-arrow-right" />
                    </Link>
                </li>
            </ul>
            {/* Pagination End */}

        </>
    );
};

export default ProductListing;